__turbopack_context__.v({
  "icon": "FansClubsToggle-module-scss-module__Da6F8q__icon",
  "segment": "FansClubsToggle-module-scss-module__Da6F8q__segment",
  "segmentActive": "FansClubsToggle-module-scss-module__Da6F8q__segmentActive",
  "toggle": "FansClubsToggle-module-scss-module__Da6F8q__toggle",
});
